<Raphael-header (openMenu)="showMenu=$event"></Raphael-header>
<Raphael-popup-menu *ngIf="showMenu" (closeMenu)="showMenu=$event"></Raphael-popup-menu>
<router-outlet></router-outlet>
<Raphael-footer></Raphael-footer>
